import store from '../store';
import airgram from '../airgram';

export default {
  async getChat({chatId}) {
    let chat = store.stores.chats.chats.find(chat => chat.id === chatId);

    if(!chat) {
      const {response} = await airgram.api.getChat({
        chatId,
      });

      chat = response;

      store.stores.chats.chats.push(chat);
    }

    return chat;
  },

  async getChatHistory(def) {
    return (await airgram.api.getChatHistory(def)).response;
  }
}
